export default __webpack_public_path__ + "static/media/Cancel Block2.edae4ae1.svg";